export default "__VITE_ASSET__DJuCV6Hj__"